import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@lucid/auth';
import { auth0Config } from './config/auth0';
import { router } from './routes';
import { UserIdentityProvider } from './components/UserIdentityProvider';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider
        domain={auth0Config.domain}
        clientId={auth0Config.clientId}
        authorizationParams={auth0Config.authorizationParams}
        cacheLocation={auth0Config.cacheLocation}
        useRefreshTokens={auth0Config.useRefreshTokens}
      >
        <UserIdentityProvider>
          <RouterProvider router={router} />
        </UserIdentityProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
